import TokenResponseCode from 'owa-service/lib/contract/TokenResponseCode';
import { getSharePointAuthToken } from 'owa-group-files-hub-adaptors';
import { PerformanceDatapoint, DatapointStatus } from 'owa-analytics';
import { parse as parseUrl } from 'url';

export interface AuthTokenError extends Error {
    resultCode: TokenResponseCode;
    isAdalException: boolean;
    // type spec field is used for determining that a given object is a AuthTokenError
    _typeSpec: 'AuthTokenError';
}

export const isAuthTokenError = (error: Error): error is AuthTokenError => {
    return (error as AuthTokenError)._typeSpec === 'AuthTokenError';
};

const getAuthority = (url: string): string => {
    const webUri = parseUrl(url);
    return `${webUri.protocol}//${webUri.host}`;
};

export const ensureAuthToken = (
    url: string,
    actionSource:
        | 'GroupFilesHubPollGroupSite'
        | 'GroupFilesHubSPItemsView'
        | 'GroupFilesHubTokenPrefetch'
        | 'GroupFilesHubSPPreviewUrl'
): Promise<string> => {
    const authorityUrl = getAuthority(url);

    const datapoint = new PerformanceDatapoint('GroupFilesHubEnsureAuthToken', { isQos: true });
    datapoint.addCustomData({ actionSource: actionSource });

    try {
        return getSharePointAuthToken(authorityUrl).then(token => {
            datapoint.end();
            return token;
        });
    } catch (exception) {
        const stringified = JSON.stringify(exception);
        datapoint.addCustomData({ error: stringified });
        const error = exception instanceof Error ? exception : new Error(stringified);
        datapoint.endWithError(DatapointStatus.ServerError, error);

        if (isAuthTokenError(exception) && exception.isAdalException) {
            throw exception;
        }

        throw new Error('Unable to get a SharePoint authentication token at this time');
    }
};
